import { api, ReactQueryOptions, RouterInputs } from '@api';
import { staleTimeIndex } from '@specs/constants';
type optionsType = ReactQueryOptions['CollectionManager']['getSingle'];
type inputType = RouterInputs['CollectionManager']['getSingle'];
export const useGetSingleCollection = (input: inputType, options?: optionsType) => api.CollectionManager.getSingle.useQuery(input, {
  ...options,
  queryKey: ['CollectionManager.getSingle', input],
  refetchOnWindowFocus: false,
  // TODO 15-минутный стейл тайм на время релиза
  staleTime: 15 * 60 * 1000 * staleTimeIndex // 15 mins
});